































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import {
  EOrigin,
  EPaymentMethodType,
  EPaymentsDepositStatus,
  EPaymentStatus,
  EUserPermissions,
  IDepositV2
} from '@zunta/configurations'
import { getPaidByLabel } from '@/utils/helpers'
import Icon from '@/components/Icon.vue'
import Confirm from '@/components/Confirm.vue'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import RefundPopup from '@/views/app/management/components/RefundPopup.vue'
import PostInPccModal from '../components/PostInPccModal.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import PaymentDepositsSubrow from '@/views/app/management/payments/components/PaymentDepositsSubrow.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusDeposit from '@/components/statuses/StatusDeposit.vue'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'

@Component({
  components: {
    ButtonDownloadReport,
    StatusDeposit,
    PaymentDepositsSubrow,
    Table,
    Card,
    FacilityLabel,
    DateTimeLabel,
    ResidentLabel,
    Icon,
    AddressesPopup,
    RefundPopup,
    Confirm,
    PostInPccModal,
    Teleport
  }
})
export default class PaymentsDeposits extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EPaymentsDepositStatus: any = EPaymentsDepositStatus
  EPaymentMethodType: any = EPaymentMethodType
  EUserPermissions: any = EUserPermissions
  EPaymentStatus: any = EPaymentStatus
  EOrigin: any = EOrigin

  getPaidByLabel: any = getPaidByLabel
  user: User = Api.getUser() as User

  needsConfirmMarkAsPostedNCSDeposit = 0
  needsConfirmPushInPccDeposit: any = null
  markAsPostedHMODeposit: any = null

  depositsInProcessing: any[] = []
  openedRow: any = null
  openedRowIndex: number = -1

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1.5rem; right: -1.5rem;',
      class: 'rounded-top-bottom'
    },
    useQuery: true,
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.paymentsModuleInstance.loadDeposits,
    rowClick: this.openPayments,
    maxHeight: 'calc(100vh - 392px)',
    minHeight: '100px',
    columns: [
      {
        minWidth: '140px',
        width: 10,
        key: 'id',
        searchKey: 'id',
        label: 'Deposit Id',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 15,
        key: 'profilesMerchantAccount',
        searchKey: 'profilesMerchantAccount',
        label: 'Facility Name',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 10,
        key: 'paymentMethodType',
        searchKey: 'paymentMethodType',
        label: 'Payment Type',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '100px',
        width: 12,
        key: 'amount',
        searchKey: 'amount',
        label: 'Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '100px',
        width: 12,
        key: 'bankAccount',
        searchKey: 'bankAccount',
        label: 'Bank Account',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '170px',
        width: 17,
        key: 'depositDate',
        searchKey: 'depositDate',
        label: 'Deposit Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '100px',
        width: 15,
        key: 'status',
        searchKey: 'status',
        label: 'Status',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.allowedStatuses
      },
      {
        class: 'text-right',
        minWidth: '190px',
        width: 19,
        key: 'actions',
        type: ETableColumnType.secondaryActions
      }
      // {
      //   minWidth: '50px',
      //   width: 5,
      //   key: 'upload',
      //   type: ETableColumnType.secondaryActions
      // }
    ]
  }

  get enableMultipleExport () {
    if (!this.depositsList || !this.depositsList.length) {
      return false
    }

    return true // this.depositsList.findIndex((deposit: IDepositV2) => !deposit.isUndeposited) > -1
  }

  get depositsList () {
    return this.$store.state.payments.deposits.deposits
  }

  get depositsPayments () {
    return this.$store.state.payments.depositPayments
  }

  get recordsTotal () {
    return this.$store.state.payments.deposits.total ? this.$store.state.payments.deposits.total : 0
  }

  get allowedStatuses () {
    return [
      {
        value: 'Undeposited',
        key: 'Undeposited',
        content: 'Undeposited'
      },
      {
        value: 'pending',
        key: 'pending',
        content: 'Pending'
      },
      {
        value: 'processed',
        key: 'processed',
        content: 'Processed'
      },
      {
        value: 'failed',
        key: 'failed',
        content: 'Failed'
      }
    ]
  }

  openPayments (deposit: any, index: any) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      this.openedRow = null
      return
    }

    this.openedRowIndex = index
    this.openedRow = deposit
  }

  closePayments () {
    this.openedRowIndex = -1
    this.openedRow = null
  }

  isDepositInProcessing (depositId: number) {
    return !!this.depositsInProcessing.find((deposit) => deposit === depositId)
  }

  async applyPaymentTo (depositId: number) {
    const deposit = this.depositsList.find((deposit: any) => deposit.id === depositId)
    if (deposit.facility.origin === EOrigin.NCS && !deposit.hmoOnly) {
      this.needsConfirmMarkAsPostedNCSDeposit = deposit.id
    } else if (deposit.facility.origin === EOrigin.PCC && !deposit.hmoOnly) {
      this.needsConfirmPushInPccDeposit = deposit
    } else if (deposit.hmoOnly) {
      this.markAsPostedHMODeposit = deposit
      await this.markAsPostedOnlyHMODeposit()
    }
  }

  async pushInPcc (date: Date | string) {
    if (this.needsConfirmPushInPccDeposit !== null) {
      const depositId = this.needsConfirmPushInPccDeposit.willowId
      this.depositsInProcessing.push(this.needsConfirmPushInPccDeposit.id)
      this.needsConfirmPushInPccDeposit = null
      await this.paymentsModuleInstance.applyPaymentToPcc({ depositId, effectiveDate: date })
      // @ts-ignore
      this.$refs.table.initSearch()
    }
  }

  async markAsPostedNCSDeposit () {
    this.depositsInProcessing.push(this.needsConfirmMarkAsPostedNCSDeposit)
    const deposit = this.depositsList.find((deposit: any) => deposit.id === this.needsConfirmMarkAsPostedNCSDeposit)
    await this.paymentsModuleInstance.applyPayment({
      depositId: deposit.willowId,
      facilityOrigin: EOrigin.NCS
    })
    this.needsConfirmMarkAsPostedNCSDeposit = 0
    // @ts-ignore
    this.$refs.table.initSearch()
  }

  async markAsPostedOnlyHMODeposit () {
    if (this.markAsPostedHMODeposit === null) {
      return
    }
    this.depositsInProcessing.push(this.markAsPostedHMODeposit.id)
    const depositId = this.markAsPostedHMODeposit.willowId
    if (this.markAsPostedHMODeposit.facility && this.markAsPostedHMODeposit.facility.origin === EOrigin.PCC) {
      await this.paymentsModuleInstance.applyPaymentToPcc({ depositId, effectiveDate: new Date() })
    } else if (this.markAsPostedHMODeposit.facility && this.markAsPostedHMODeposit.facility.origin === EOrigin.NCS) {
      await this.paymentsModuleInstance.applyPayment({ depositId, facilityOrigin: EOrigin.NCS })
    }
    this.markAsPostedHMODeposit = null
    // @ts-ignore
    this.$refs.table.initSearch()
  }

  exportDeposit (id?: number) {
    if (!this.depositsList || !this.depositsList.length || !id) {
      return
    }
    this.paymentsModuleInstance.exportDeposit(id)
  }

  exportDeposits () {
    if (!this.depositsList || !this.depositsList.length) {
      return
    }
    this.paymentsModuleInstance.exportDeposits({ ...this.$route.query })
  }
}
